import { Helmet } from "react-helmet";
import hero from "../images/joinHero.jpg";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Button from "react-bootstrap/Button";

function Survey() {
  const form = useRef();

  const [referral, setReferral] = useState("");
  const [email, setEmail] = useState("");
  const [tour, setTour] = useState("");
  const [arrival, setArrival] = useState(""); // yes / no
  const [location, setLocation] = useState(""); // only if arrival === "no"
  const [cart, setCart] = useState("");
  const [better, setBetter] = useState("");

  const [errorReferral, setErrorReferral] = useState("formInput");
  const [errorEmail, setErrorEmail] = useState("formInput");
  const [errorTour, setErrorTour] = useState("formInput");
  const [errorArrival, setErrorArrival] = useState("formInput");
  const [errorLocation, setErrorLocation] = useState("formInput");
  const [errorCart, setErrorCart] = useState("formInput");
  const [errorBetter, setErrorBetter] = useState("formInput");
  const [waitMessage, setWaitMessage] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!referral) {
      setErrorReferral("errorFormInput");
    } else setErrorReferral("formInput");

    if (!tour) {
      setErrorTour("errorFormInput");
    } else setErrorTour("formInput");

    if (!arrival) {
      setErrorArrival("errorFormInput");
    } else setErrorArrival("formInput");

    if (!cart) {
      setErrorCart("errorFormInput");
    } else setErrorCart("formInput");

    const isValid = referral && tour && cart && arrival;

    if (isValid) {
      setWaitMessage("Please wait...");

      emailjs
        .sendForm(
          "service_8kmbiu2",
          "template_n2r217p",
          form.current,
          "lIvuQcS29W-1LzLJc"
        )
        .then(
          function (response) {
            setReferral("");
            setEmail("");
            setTour("");
            setArrival("");
            setLocation("");
            setCart("");
            setBetter("");
            setWaitMessage("Thank you for your responses!");
            console.log("SUCCESS!", response.status, response.text);
          },
          function (err) {
            console.log("FAILED...", err);
            setWaitMessage(
              "There was an error. Please reload the page and try again"
            );
          }
        );
    } else {
      setWaitMessage("Required field(s) missing. Please check form.");
    }
  };

  return (
    <>
      <Helmet>
        <title>Atlantis Submarine Adventures | Survey</title>
      </Helmet>
      <div className="container mw-100">
        <div className="row">
          <img src={hero} className="p-0 aboutHero" alt="hero" />
        </div>
      </div>
      <p
        className="fs-2 fw-bold mb-5 mt-5 text-center"
        style={{ color: "#03286B" }}
      >
        SURVEY
      </p>
      <div className="container pb-5" style={{ maxWidth: "800px" }}>
        <div
          className="row bg-white justify-content-center"
          style={{ color: "#03286B" }}
        >
          <div className="jobForm">
            <form ref={form} id="jobsForm" onSubmit={onSubmit}>
              <div className="container-fluid">
                {/* Referral – its own row */}
                <div className="row justify-content-center pt-3">
                  <div className="col-12">
                    <label className="formLabel d-block mb-2">
                      How did you hear about us?
                    </label>
                    <select
                      className={errorReferral}
                      value={referral}
                      name="referral"
                      onChange={(e) => {
                        setReferral(e.target.value);
                        setErrorReferral("formInput");
                      }}
                    >
                      <option value="" disabled>
                        Please select
                      </option>
                      <option value="Searching for Activities in Hawaii">
                        Searching for Activities in Hawaii
                      </option>
                      <option value="From a friend who has booked with Atlantis or Majestic">
                        From a friend who has booked with Atlantis or Majestic
                      </option>
                      <option value="Social media">Social media</option>
                      <option value="Google search ad/other digital ad">
                        Google search ad/other digital ad
                      </option>
                      <option value="Airport video">Airport video</option>
                      <option value="Signage">Signage</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>

                {/* Arrival Yes/No – its own question/row */}
                <div className="row justify-content-center">
                  <div className="col-12">
                    <label className="formLabel d-block mb-2">
                      Did you first visit our website during your Hawaiian
                      vacation?
                    </label>
                    <select
                      className={errorArrival}
                      value={arrival}
                      name="arrival"
                      onChange={(e) => {
                        setArrival(e.target.value);
                        setErrorArrival("formInput");
                      }}
                    >
                      <option value="" disabled>
                        Please select
                      </option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>

                {/* Location – only shown if arrival === "no" */}
                {arrival === "no" && (
                  <div className="row justify-content-center">
                    <div className="col-12">
                      <input
                        className={errorLocation}
                        value={location}
                        name="location"
                        type="text"
                        placeholder="If not, where do you reside? (City, State)"
                        onChange={(e) => {
                          setLocation(e.target.value);
                          setErrorLocation("formInput");
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Tour – its own row */}
                <div className="row justify-content-center">
                  <div className="col-12">
                    <label className="formLabel d-block mb-2">
                      Which boat tour are you interested in?
                    </label>
                    <select
                      className={errorTour}
                      value={tour}
                      name="tour"
                      onChange={(e) => {
                        setTour(e.target.value);
                        setErrorTour("formInput");
                      }}
                    >
                      <option value="" disabled>
                        Your Tour
                      </option>
                      <option>Waikiki Subarmine</option>
                      <option>Kona Submarine</option>
                      <option>Waikiki Sunset Cocktail Cruise</option>
                      <option>
                        Waikiki Friday Fireworks & Cocktail Cruise
                      </option>
                      <option>Whale Watch Cruise</option>
                    </select>
                  </div>
                </div>

                {/* What is keeping you from completing your purchase – dropdown */}
                <div className="row justify-content-center">
                  <div className="col-12">
                    <label className="formLabel d-block mb-2">
                      What is keeping you from completing your booking?
                    </label>
                    <select
                      className={errorCart}
                      value={cart}
                      name="cart"
                      onChange={(e) => {
                        setCart(e.target.value);
                        setErrorCart("formInput");
                      }}
                    >
                      <option value="" disabled>
                        Please select
                      </option>
                      <option>Too expensive</option>
                      <option>Just exploring activities in Hawaii</option>
                      <option>Waiting on specials or deals</option>
                      <option>
                        I have more questions about the submarines
                      </option>
                      <option>
                        I would like to learn more about the cruises
                      </option>
                    </select>
                  </div>
                </div>

                {/* About Yourself – its own row */}
                <div className="row justify-content-center">
                  <div className="col-12">
                    <label className="formLabel d-block mb-2">
                      If you could tell us more, we would love to learn how we
                      can improve.
                    </label>
                    <textarea
                      rows="8"
                      className={errorBetter}
                      value={better}
                      name="better"
                      onChange={(e) => {
                        setBetter(e.target.value);
                        setErrorBetter("formInput");
                      }}
                    />
                  </div>
                </div>

                {/* Email – its own row */}
                <div className="row justify-content-center">
                  <div className="col-12">
                    <label className="formLabel d-block mb-2">
                      Please leave your email address, so we can send you
                      updates and specials. Thank you!
                    </label>
                    <input
                      className={errorEmail}
                      value={email}
                      name="email"
                      type="email"
                      placeholder="Email Address"
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrorEmail("formInput");
                      }}
                    />
                  </div>
                </div>

                {waitMessage ? (
                  <p className="waitMessage">{waitMessage}</p>
                ) : (
                  ""
                )}
                <Button className="jobFormButton" variant="dark" type="submit">
                  Send
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Survey;
